import { useState,useRef } from "react";
import { useLocation } from "react-router-dom";

export default function C2CTransferJson() {
  const { pathname } = useLocation();
  const [activeTab, setActiveTab] = useState(1);
  const [activeTabSecond, setActiveTabSecond] = useState(3);
  const [activeTabThird, setActiveTabThird] = useState(5);
  const [activeTabFourth, setActiveTabFourth] = useState(7);
  const [activeTabFifth, setActiveTabFifth] = useState(8);
  const [activeTabSix, setActiveTabSix] = useState(10);
  const copyBodyRef = useRef(null);
  const copyBodyRef1 = useRef(null);
  const copyBodyRef2 = useRef(null);
  const copyBodyRef3 = useRef(null);
  const copyBodyRef4 = useRef(null);
  const copyBodyRef5 = useRef(null);
  const [copied, setCopied] = useState(false);

 const handleCopy = (ref) => {
    const text = ref.current.innerText;
    navigator.clipboard.writeText(text).then(() => {
      setCopied(true);
      setTimeout(() => setCopied(false), 2000); 
    });
  };

   const formHtml =`<form id="formCReq" name="formCReq" action="https://acstest.libertybank.ge" method="post">
          <input type="hidden" id="creq" name="creq"
value="eyJhY3NUcmFuc0lEIjoiYzBjOTMyNTctYjZkYy00NWJlLTgwZGItMDIxYTVjYjE1NzZiIiwidGhyZWVEU1Nlc
nZlclRyYW5zSUQiOiJkM2YzNTBjOC04NGFmLTQ5N2QtYjEyMS04YmRjODQ5MmVmYTgiLCJjaGFsbGVuZ2VXa
W5kb3dTaXplIjoiMDUiLCJtZXNzYWdlVHlwZSI6IkNSZXEiLCJtZXNzYWdlVmVyc2lvbiI6IjIuMi4wIn0" />
          </form>`;
  return (
    <>
      <div className="doc-content">
        <h3 className="text-left pb-24 doc-title">C2C Transfer (Merchant Do not need PCI DSS )</h3>
        <h4 className="pb-16 sub-title flex-items-center">
          <span className="xml-icon">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="21.477"
              height="25.499"
              viewBox="0 0 21.477 25.499"
            >
              <g
                id="Type_Code_-_JSON_Style_Default"
                data-name="Type= Code - JSON, Style=Default"
                transform="translate(-1)"
              >
                <path
                  id="Path_6089"
                  data-name="Path 6089"
                  d="M23.516,5.448V22.723a2.026,2.026,0,0,1-2.026,2.026H7.776A2.026,2.026,0,0,1,5.75,22.723V2.776A2.026,2.026,0,0,1,7.776.75H18.4Z"
                  transform="translate(-1.789)"
                  fill="none"
                  stroke="#d0d5dd"
                  stroke-width="1.5"
                />
                <path
                  id="Path_6090"
                  data-name="Path 6090"
                  d="M24.623,1h0Zm5.3,5.922H25.247A1.247,1.247,0,0,1,24,5.675h5.922Zm-4.675,0A1.247,1.247,0,0,1,24,5.675V1h1.247V6.922ZM29.922,1V1Z"
                  transform="translate(-8.663 -0.094)"
                  fill="#d0d5dd"
                />
                <rect
                  id="Rectangle_2269"
                  data-name="Rectangle 2269"
                  width="19.947"
                  height="8.104"
                  rx="2"
                  transform="translate(1 12.75)"
                  fill="#2d3282"
                />
                <path
                  id="Path_6091"
                  data-name="Path 6091"
                  d="M6.57,22.942v2.98a1.4,1.4,0,0,1-.393,1.066,1.442,1.442,0,0,1-1.047.374,1.554,1.554,0,0,1-1.11-.393A1.457,1.457,0,0,1,3.6,25.853h1.06a.667.667,0,0,0,.112.418.4.4,0,0,0,.324.137.371.371,0,0,0,.3-.125.544.544,0,0,0,.106-.362v-2.98Zm2.444,4.42a2.251,2.251,0,0,1-.86-.156,1.424,1.424,0,0,1-.611-.461,1.273,1.273,0,0,1-.237-.736H8.441a.563.563,0,0,0,.168.374.55.55,0,0,0,.374.125.6.6,0,0,0,.374-.106.374.374,0,0,0,.137-.305.353.353,0,0,0-.112-.268.831.831,0,0,0-.268-.175,4.045,4.045,0,0,0-.449-.156,4.923,4.923,0,0,1-.692-.262,1.279,1.279,0,0,1-.461-.386,1.077,1.077,0,0,1-.193-.667,1.138,1.138,0,0,1,.443-.954,1.808,1.808,0,0,1,1.153-.349,1.828,1.828,0,0,1,1.166.349,1.229,1.229,0,0,1,.474.96H9.4a.44.44,0,0,0-.156-.33.54.54,0,0,0-.368-.125.45.45,0,0,0-.312.106.362.362,0,0,0-.118.293.367.367,0,0,0,.2.33,3.272,3.272,0,0,0,.623.256,5.547,5.547,0,0,1,.686.274,1.3,1.3,0,0,1,.461.38,1.018,1.018,0,0,1,.193.642,1.245,1.245,0,0,1-.193.679,1.309,1.309,0,0,1-.549.486A1.889,1.889,0,0,1,9.014,27.362Zm4.321,0a2.3,2.3,0,0,1-1.135-.287,2.18,2.18,0,0,1-.817-.8,2.274,2.274,0,0,1-.3-1.159,2.24,2.24,0,0,1,.3-1.153,2.18,2.18,0,0,1,.817-.8,2.3,2.3,0,0,1,1.135-.287,2.266,2.266,0,0,1,1.128.287,2.078,2.078,0,0,1,.81.8,2.24,2.24,0,0,1,.3,1.153,2.274,2.274,0,0,1-.3,1.159,2.134,2.134,0,0,1-.81.8A2.266,2.266,0,0,1,13.336,27.362Zm0-.972a1.064,1.064,0,0,0,.835-.349,1.317,1.317,0,0,0,.318-.923,1.3,1.3,0,0,0-.318-.923,1.064,1.064,0,0,0-.835-.349,1.1,1.1,0,0,0-.848.343,1.328,1.328,0,0,0-.312.929,1.342,1.342,0,0,0,.312.929A1.1,1.1,0,0,0,13.336,26.39Zm6.746.929H19.015l-1.783-2.7v2.7H16.167V22.942h1.066l1.783,2.712V22.942h1.066Z"
                  transform="translate(-0.98 -8.335)"
                  fill="#fff"
                />
              </g>
            </svg>
          </span>
          <span className="pl-12"> JSON</span>
        </h4>
        
        <div className="sub-link flex-items-center pb-12">
          <p className="black">Example of the request url:</p>
          <a
            href=" https://libertypaytxtest.lb.ge:6444/order?terminalid=442"
            target="_blank"
            className="link fnt-14 underline pl-8"
          >
            https://libertypaytxtest.lb.ge:6444/order?terminalid=442
          </a>
        </div>
      
        <div className="sub-link flex-items-center pb-32">
          <p className="black">Example of Authorization Header:</p>
          <a
            href="#"
            target="_blank"
            className="link fnt-14 underline pl-8"
          >
            Basic  VGVybWluYWxTeXMvSUEtQzJDLVRSQU5TRkVSLUhUUDoxMjNpb3BJT1Aj
          </a>
        </div>
        <div className="tabs-content">
          <div className="flex-items-center tabs-header">
            {/* tabs content */}
            <div className="tabs-button">
              <div
                className={activeTab === 1 ? "active-tab" : "tab"}
                onClick={() => setActiveTab(1)}
              >
                Request
              </div>
              <div
                className={activeTab === 2 ? "active-tab" : "tab"}
                onClick={() => setActiveTab(2)}
              >
                Response
              </div>
            </div>
             <button
              className={`btn btn-copy ${copied ? "copied" : ""}`}
              onClick={() => handleCopy(copyBodyRef)}
            >
              <svg
                width="24px"
                height="24px"
                viewBox="0 0 24 24"
                version="1.1"
                xmlns="http://www.w3.org/2000/svg"
               >
                <g
                  id="Organization-/-File-/-copy--file"
                  stroke="none"
                  stroke-width="1"
                  fill="none"
                  fill-rule="evenodd"
                >
                  <rect
                    fill="#FFFFFF"
                    opacity="0"
                    x="0"
                    y="0"
                    width="24"
                    height="24"
                  ></rect>
                  <path
                    d="M20.55,11.025 L15.975,6.45 C15.75,6.15 15.375,6 15,6 L9,6 C8.175,6 7.5,6.675 7.5,7.5 L7.5,21 C7.5,21.825 8.175,22.5 9,22.5 L19.5,22.5 C20.325,22.5 21,21.825 21,21 L21,12.075 C21,11.7 20.85,11.325 20.55,11.025 Z M15,7.5 L19.425,12 L15,12 L15,7.5 Z M9,21 L9,7.5 L13.5,7.5 L13.5,12 C13.5,12.825 14.175,13.5 15,13.5 L19.5,13.5 L19.5,21 L9,21 Z M4.5,13.5 L3,13.5 L3,3 C3,2.175 3.675,1.5 4.5,1.5 L15,1.5 L15,3 L4.5,3 L4.5,13.5 Z"
                    id="Fill"
                    fill="#fff"
                  ></path>
                </g>
              </svg>
              <span className="pl-6"> {copied ? "Copied" : "Copy"} </span>
            </button>
          </div>

          <div className="tab-content">
            {activeTab === 1 ? (
              <>
                <div className="code-ceontent">
                  <div className="code-body">
                 
                    <pre
                      ref={copyBodyRef}
                      tabIndex="0"
                      style={{ whiteSpace: "pre-wrap" }}
                    >
                      <code >
                        <span className="token-line">
                          <span className="token punctuation">{'{'}</span>
                          <span className="token plain"></span>
                          <br />
                        </span>
                        <span className="token-line">
                          <span className="token plain">   </span>
                          <span className="token head">"order"</span>
                          <span className="token operator operator">{':'}</span>
                          <span className="token punctuation">{'{'}</span>
                          <span className="token plain"></span>
                          <br />
                        </span>
                        <span className="token-line">
                          <span className="token plain">     </span>
                          <span className="token">"typeRid"</span>
                          <span className="token operator">{':'}</span>
                          <span className="token property">"C2C-Transfer"</span>
                          <span className="token punctuation">{','}</span>
                          <span className="token plain"></span>
                          <br />
                        </span>
                        <span className="token-line">
                          <span className="token plain">     </span>
                          <span className="token ">"language"</span>
                          <span className="token operator">{':'}</span>
                          <span className="token property">"ka"</span>
                          <span className="token punctuation">{','}</span>
                          <span className="token plain"></span>
                          <br />
                        </span>
                        <span className="token-line">
                          <span className="token plain">     </span>
                          <span className="token ">"amount"</span>
                          <span className="token operator">{':'}</span>
                          <span className="token property">"25.00"</span>
                          <span className="token punctuation">{','}</span>
                          <span className="token plain"></span>
                          <br />
                        </span>
                        <span className="token-line">
                          <span className="token plain">     </span>
                          <span className="token ">"currency"</span>
                          <span className="token operator">{':'}</span>
                          <span className="token property">"GEL"</span>
                          <span className="token punctuation">{','}</span>
                          <span className="token plain"></span>
                          <br />
                        </span>
                        
                         <span className="token-line">
                          <span className="token plain">     </span>
                          <span className="token ">"hppRedirectUrl"</span>
                          <span className="token operator">{':'}</span>
                          <span className="token property">"https://merchantPage.com/?"</span>
                          <span className="token punctuation">{','}</span>
                          <span className="token plain"></span>
                          <br />
                        </span>
                        <span className="token-line">
                          <span className="token plain">     </span>
                          <span className="token ">"description"</span>
                          <span className="token operator">{':'}</span>
                          <span className="token property">"Lololo"</span>
                          <span className="token plain"></span>
                          <br />
                        </span>
                        <span className="token-line">
                          <span className="token plain">     </span>
                          <span className="token punctuation">{'}'}</span>
                          <br />
                        </span>
                       
                       
                        <span className="token-line">
                          <span className="token plain"></span>
                          <span className="token punctuation">{'}'}</span>
                          <br />
                        </span>
                        
                        
                      </code>
                    </pre>
                   
                  </div>
                </div>
               
              </>
            ) : (
              <>
                <div className="code-ceontent">
                  <div className="code-body">
                    <pre  ref={copyBodyRef} style={{ whiteSpace: "pre-wrap" }}>
                      <code>
                        <span className="token-line">
                          <span className="token punctuation">{'{'}</span>
                          <span className="token plain"></span>
                          <br />
                        </span>
                        <span className="token-line">
                          <span className="token plain">   </span>
                          <span className="token head">"order"</span>
                          <span className="token operator operator">{':'}</span>
                          <span className="token punctuation">{'{'}</span>
                          <span className="token plain"></span>
                          <br />
                        </span>
                        <span className="token-line">
                          <span className="token plain">     </span>
                          <span className="token">"id"</span>
                          <span className="token operator">{':'}</span>
                          <span className="token property">22131</span>
                          <span className="token punctuation">{','}</span>
                          <span className="token plain"></span>
                          <br />
                        </span>
                        <span className="token-line">
                          <span className="token plain">     </span>
                          <span className="token">"htpUrl"</span>
                          <span className="token operator">{':'}</span>
                          <span className="token property">"https://libertypaytxtest.lb.ge/flex"</span>
                          <span className="token punctuation">{','}</span>
                          <span className="token plain"></span>
                          <br />
                        </span>
                        <span className="token-line">
                          <span className="token plain">     </span>
                          <span className="token">"password"</span>
                          <span className="token operator">{':'}</span>
                          <span className="token property">"2ayeaetuypai"</span>
                          <span className="token punctuation">{','}</span>
                          <span className="token plain"></span>
                          <br />
                        </span>
                        <span className="token-line">
                          <span className="token plain">     </span>
                          <span className="token">"status"</span>
                          <span className="token operator">{':'}</span>
                          <span className="token property">"Preparing"</span>
                          <span className="token punctuation">{','}</span>
                          <span className="token plain"></span>
                          <br />
                        </span>
                        
                        <span className="token-line">
                          <span className="token plain">     </span>
                          <span className="token">"cvv2AuthStatus"</span>
                          <span className="token operator">{':'}</span>
                          <span className="token property">"Required"</span>
                          <span className="token plain"></span>
                          <br />
                        </span>
                        <span className="token-line">
                          <span className="token plain">   </span>
                          <span className="token punctuation">{'}'}</span>
                          <br />
                        </span>
                        <span className="token-line">
                          <span className="token plain"></span>
                          <span className="token punctuation">{'}'}</span>
                          <br />
                        </span>
                      </code>
                    </pre>
                  </div>
                </div>
               
              </>
            )}{" "}
          </div>
        </div>


        {/* Creating Source Token: */}
        <h5 className="step-title">After the merchant receives the id and password, they must redirect the client to the following address:</h5>
        <div className="sub-link flex-items-center pb-12">
          <p className="black">Example of the request url:</p>
          <a
            href="https://libertypaytxtest.lb.ge/flex/?id=22127&password=wxapo8p82mqq "
            target="_blank"
            className="link fnt-14 underline pl-8"
          >
            https://libertypaytxtest.lb.ge/flex/?id=22127&password=wxapo8p82mqq 
          </a>
        </div>
        <div className="sub-link flex-items-center pb-12">
          <p className="black">On the Liberty payment page, the client must</p>
          <span>Enter the Target card PAN .</span><br/>
        </div>
        <div className="sub-link flex-items-center pb-12">
          <p className="black">Click "Transfer by Card".</p>
          
        </div>
        <div className="sub-link flex-items-center pb-12">
          <p className="black">On the next step, provide the source card details, either:</p>
          <span
           className=" fnt-14  pl-8"
          >
            Manually, Via Google Pay, or Apple Pay.

          </span>
        </div>
        <div className="sub-link flex-items-center pb-32">
          <p className="black">Once the source card is entered, the client will be redirected to the issuer’s 3D Secure (3DS) page to enter the OTP. 
            After successful authentication, the transaction is completed.</p>
          
        </div>
      



      
      </div>
    </>
  );
}
